/*!
  * Owl v1.0.0 (git@bitbucket.org:devasghar/owl.git)
  */
/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.ncmAdmin = {
    attach: function (context, settings) {
      Drupal.behaviors.ncmAdmin.viewsBlocks();
    }
  };

  /**
   * Search submission
   */
  Drupal.behaviors.ncmAdmin.viewsBlocks = function (context, settings) {
    var adminView = $('.admin-form');
    $(adminView).find('.views-row').on('click', function () {
      $(this).find('input[type=checkbox]').prop( "checked", true );
      $(this).toggleClass('active');
    });
  };

})(jQuery, Drupal);
